import { RelatedProductSlider } from "./js/ClassRelatedProductSlider";

window.addEventListener("DOMContentLoaded", () => {
	const relatedProductSliders = document.querySelectorAll(
		".related-product-slider"
	);

	relatedProductSliders.forEach((s) => {
		const x = new RelatedProductSlider(s);
		x.init();
	});
});
